<div>{{ message() }}</div>
<button mat-button (click)="expand()"><mat-icon>open_in_new</mat-icon></button>
